export default function LegalPage({ eyebrow, title, intro, sections, downloadUrl }) {
  return (
    <article data-testid="legal-page" className="ct-container py-20 md:py-28">
      <header className="max-w-3xl">
        <span className="ct-eyebrow">{eyebrow}</span>
        <h1 className="mt-4 font-display text-4xl font-bold leading-tight tracking-tight text-[#0F172A] sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 text-lg leading-relaxed text-slate-600">{intro}</p>
        )}
      </header>

      <div className="mt-14 grid gap-12 lg:grid-cols-12">
        <aside className="hidden lg:col-span-3 lg:block">
          <nav className="sticky top-24">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
              On this page
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              {sections.map((s) => (
                <li key={s.id}>
                  <a
                    href={`#${s.id}`}
                    className="block rounded-md px-2 py-1.5 text-slate-600 hover:bg-neutral-50 hover:text-neutral-700"
                  >
                    {s.heading}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </aside>

        <div className="lg:col-span-9">
          <div className="space-y-12">
            {sections.map((s) => (
              <section key={s.id} id={s.id} className="scroll-mt-24">
                <h2 className="font-display text-2xl font-semibold tracking-tight text-[#0F172A] md:text-3xl">
                  {s.heading}
                </h2>
                <div className="prose-content mt-4 space-y-4 text-base leading-relaxed text-slate-600">
                  {s.body.map((p, i) => (
                    <p key={i}>{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          {downloadUrl && (
            <div className="mt-14 rounded-2xl border border-neutral-200 bg-neutral-50/60 p-6">
              <p className="font-display text-lg font-semibold text-[#0F172A]">
                Need the full document?
              </p>
              <p className="mt-1 text-sm text-slate-600">
                Download the complete signed version for your records.
              </p>
              <a
                href={downloadUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="legal-download"
                className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#262626]"
              >
                Download document
              </a>
            </div>
          )}
        </div>
      </div>
    </article>
  );
}
